/**
 * Warm lazy route chunks on hover/focus before navigation (predictive prefetch).
 * Mirrors dynamic imports in `AppRoutes.tsx` so Vite reuses the same chunks.
 */
export function prefetchAppRoute(path: string): void {
  if (typeof window === "undefined") return

  const normalized = path.split("?")[0].split("#")[0]

  const run = (fn: () => Promise<unknown>) => {
    void fn().catch(() => {})
  }

  switch (normalized) {
    case "/today":
      run(() => import("../pages/HomePage").then((m) => m.HomePage))
      break
    case "/play":
      run(() => import("../pages/PlayPage"))
      break
    case "/plans":
      run(() => import("../pages/PlansPage").then((m) => m.PlansPage))
      break
    case "/remember":
      run(() => import("../pages/RememberPage").then((m) => m.RememberPage))
      break
    case "/me":
      run(() => import("../pages/MePage").then((m) => m.MePage))
      break
    case "/theme":
      run(() => import("../pages/ThemePage").then((m) => m.ThemePage))
      break
    default:
      if (normalized.startsWith("/plans/")) {
        run(() => import("../pages/PlanDetailPage").then((m) => m.PlanDetailPage))
      }
      break
  }
}
